import { useMemberRole } from "Components/Members/hooks/useMemberRole";
import { MemberRole } from "domain-entities";

export const useIsInternalAdmin = () => {
	const memberRole = useMemberRole();

	if (!memberRole) return false;

	return [MemberRole.OWNER, MemberRole.SUPERVISOR].includes(memberRole);
};
